@if (webViewerJsonFileId) {
	<div class="web-viewer">
		@if (productName) {
			<h2>
				{{ "WebViewer" | translate }}<span> - {{ productName }}</span>
			</h2>
		}
		<iframe [src]="caWebViewerUrl" #caWebViewer [ngClass]="{
							'loading': (webviewerLoadingFinished$ | async) === null,
						}">
		</iframe>
		@if ((webviewerLoadingFinished$ | async) === null) {
			<div class="loading-spinner">
				<fa-icon [icon]="faSpinner" animation="spin"></fa-icon>
			</div>
		}
		@if (showCopyLinkButton || modificationModeEntered === false) {
			<div class="buttons-container">
				@if (showCopyLinkButton) {
					<button
						mat-button
						color="default"
						ngxClipboard
						title="{{ webViewerUrl }}"
						[cbContent]="webViewerUrl"
					>
						<fa-icon [icon]="faSignInAlt"></fa-icon> {{ "Zwischenablage" | translate }}
					</button>
				}
				@if (modificationModeEntered === false) {
					<div class="modification-mode-buttons">
						<button mat-raised-button color="default" (click)="openAnnotationHelpDialog()" data-cy="modification-help-button"
							[title]="'WebviewerAnnotationHelpTitle' | translate">
							<fa-icon [icon]="faQuestionCircle"></fa-icon> {{ "WebviewerAnnotationHelp" | translate }}
						</button>
						<button mat-raised-button color="default" (click)="requestCancelModification(false)"
							data-cy="modification-cancel-button">
							<fa-icon [icon]="faTimes"></fa-icon> {{ "WebviewerModificationCancelAnnotation" | translate }}
						</button>
						<button mat-raised-button color="primary" (click)="requestSubmitModification(false)"
							[disabled]="modificationHasComments !== true" data-cy="modification-complete-button">
							<fa-icon [icon]="faCheckToSlot"></fa-icon> {{ "WebviewerModificationCompleteAnnotation" | translate }}
						</button>
					</div>
				}
			</div>
		}
	</div>
}
@if (alternativeOptionWebviewerFileId) {
	<div class="web-viewer">
		<h2>
			{{ "WebViewer" | translate }} <span> - {{ "Alternative Option" | translate }}</span> -
			{{ alternativeOptionProductName }}
		</h2>
		<iframe [src]="caWebViewerUrl" #caWebViewerAlternative [ngClass]="{
					'loading': (webviewerAlternativeLoadingFinished$ | async) === null,
				}">
		</iframe>
		@if ((webviewerAlternativeLoadingFinished$ | async) === null) {
			<div class="loading-spinner">
				<fa-icon [icon]="faSpinner" animation="spin"></fa-icon>
			</div>
		}
		@if (showCopyLinkButton || modificationModeEntered === true) {
			<div class="buttons-container">
				@if (showCopyLinkButton) {
					<button
						mat-button
						color="default"
						ngxClipboard
						title="{{ webViewerUrlAlternativeOption }}"
						[cbContent]="webViewerUrlAlternativeOption"
					>
						<fa-icon [icon]="faSignInAlt"></fa-icon> {{ "Zwischenablage" | translate }}
					</button>
				}
				@if (modificationModeEntered === true) {
					<div class="modification-mode-buttons">
						<button mat-raised-button color="default" (click)="openAnnotationHelpDialog()" data-cy="modification-help-button"
							[title]="'WebviewerAnnotationHelpTitle' | translate">
							<fa-icon [icon]="faQuestionCircle"></fa-icon> {{ "WebviewerAnnotationHelp" | translate }}
						</button>
						<button mat-raised-button color="default" (click)="requestCancelModification(true)"
							data-cy="modification-cancel-button">
							<fa-icon [icon]="faTimes"></fa-icon> {{ "WebviewerModificationCancelAnnotation" | translate }}
						</button>
						<button mat-raised-button color="primary" (click)="requestSubmitModification(true)"
							data-cy="modification-complete-button" [disabled]="modificationHasCommentsAlternativeOption !== true">
							<fa-icon [icon]="faCheckToSlot"></fa-icon> {{ "WebviewerModificationCompleteAnnotation" | translate }}
						</button>
					</div>
				}
			</div>
		}
	</div>
}
